import { render } from "./payslipsTemplatesEdit.vue?vue&type=template&id=03e8ac2d"
import script from "./payslipsTemplatesEdit.vue?vue&type=script&lang=js"
export * from "./payslipsTemplatesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__